<template>
    <div class="flex flex-column gap-2 pt-3">
        <label class="Label align-self-start">
            {{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <slot></slot>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    label: {
        type: String,
        required: true
    },
    required: {
        type: Boolean,
        default: false
    }
});
</script>